var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 30,
    viewBox: "0 0 37 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2316_4191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.8074 4.11986C31.489 2.92079 30.5509 1.97657 29.3596 1.65612C27.2004 1.07373 18.5421 1.07373 18.5421 1.07373C18.5421 1.07373 9.88393 1.07373 7.72469 1.65612C6.53344 1.97657 5.59519 2.92079 5.27681 4.11986C4.69824 6.29308 4.69824 10.8274 4.69824 10.8274C4.69824 10.8274 4.69824 15.3616 5.27681 17.535C5.59519 18.734 6.53344 19.6782 7.72469 19.9988C9.88393 20.581 18.5421 20.581 18.5421 20.581C18.5421 20.581 27.2004 20.581 29.3596 19.9988C30.5509 19.6782 31.489 18.734 31.8074 17.535C32.386 15.3616 32.386 10.8274 32.386 10.8274C32.386 10.8274 32.386 6.29308 31.8074 4.11986Z",
    fill: "#EA5A47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.71 14.944L22.9465 10.8274L15.71 6.71045V14.944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8074 4.11986C31.489 2.92079 30.5509 1.97657 29.3596 1.65612C27.2004 1.07373 18.5421 1.07373 18.5421 1.07373C18.5421 1.07373 9.88393 1.07373 7.72469 1.65612C6.53344 1.97657 5.59519 2.92079 5.27681 4.11986C4.69824 6.29308 4.69824 10.8274 4.69824 10.8274C4.69824 10.8274 4.69824 15.3616 5.27681 17.535C5.59519 18.734 6.53344 19.6782 7.72469 19.9988C9.88393 20.581 18.5421 20.581 18.5421 20.581C18.5421 20.581 27.2004 20.581 29.3596 19.9988C30.5509 19.6782 31.489 18.734 31.8074 17.535C32.386 15.3616 32.386 10.8274 32.386 10.8274C32.386 10.8274 32.386 6.29308 31.8074 4.11986Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.71 14.944L22.9465 10.8274L15.71 6.71045V14.944Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2316_4191",
    x: 0.198242,
    y: 0.57373,
    width: 36.6875,
    height: 28.5073,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2316_4191"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2316_4191",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.037ca002055ec9b43290157e993c12db.svg";
export { ForwardRef as ReactComponent };